import type { ApprovalChain } from '../approval-chain.model';

export const DEED_SUBDIVISION_BOND_CHAIN: ApprovalChain = {
  id: 'deed-subdivision-bond',
  label: 'Subdivision/Deduction with Bond',
  applicationTypes: ['DEED_SUBDIVISION_BOND'],
  steps: [
    {
      role: 'FIRST_BANK_USER',
      action: 'Recommend',
      from: ['LOCAL_GOVERNMENT_APPROVED', 'RESUBMITTED', 'SUBMITTED', 'PENDING', 'MINISTRY_OF_LANDS_DIRECTOR_LEGAL_APPROVED'],
      to: 'FIRST_BANK_USER_APPROVED',
    },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['FIRST_BANK_USER_APPROVED', 'SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Approve', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_APPROVED' },
    { role: 'SURVEYOR_GENERAL_TECHNICIAN', action: 'Recommend', from: ['REGISTRAR_APPROVED'], to: 'SG_TECHNICIAN_RECOMMENDED' },
    { role: 'SURVEYOR_GENERAL', action: 'Approve', from: ['SG_TECHNICIAN_RECOMMENDED'], to: 'APPROVED' },
  ],
};
